// extracted by mini-css-extract-plugin
export default {"over":"TimeLimit_over__3X3dJ","limit":"TimeLimit_limit__1Xlyf"};